import React from 'react';
import { injectIntl } from 'react-intl';

import FormInput from 'components/forms/FormInput';
import FormCheckbox from 'components/forms/FormCheckbox';

class CmsCommonSettings extends React.Component {
  handleResponsiveHideChange = (name, values) => {
    const { setParams } = this.props;

    setParams([
      { name: 'hiddenPhone', value: values.indexOf('phone') > -1 ? 'yes' : 'no' },
      { name: 'hiddenTablet', value: values.indexOf('tablet') > -1 ? 'yes' : 'no' },
      { name: 'hiddenDesktop', value: values.indexOf('desktop') > -1 ? 'yes' : 'no' },
    ]);
  };

  handleRowSameHeightChange = (name, values) => {
    const { setParams } = this.props;

    setParams([
      { name: 'colSameHeightPhone', value: values.indexOf('phone') > -1 ? 'yes' : 'no' },
      { name: 'colSameHeightTablet', value: values.indexOf('tablet') > -1 ? 'yes' : 'no' },
      { name: 'colSameHeightDesktop', value: values.indexOf('desktop') > -1 ? 'yes' : 'no' },
    ]);
  };

  getValues = () => {
    const { getParamValue } = this.props;
    const values = [];

    if (getParamValue('hiddenPhone', 'no') === 'yes') {
      values.push('phone');
    }
    if (getParamValue('hiddenTablet', 'no') === 'yes') {
      values.push('tablet');
    }
    if (getParamValue('hiddenDesktop', 'no') === 'yes') {
      values.push('desktop');
    }

    return values;
  };

  render() {
    const {
      intl: { messages },
      element,
      getParamValue,
      setParam,
    } = this.props;

    return (
      <>
        <div class="form-group-attached">
          <FormInput label="Label" name="elementLabel" value={getParamValue('elementLabel')} onChange={setParam} />
          <FormInput label="ID" name="elementId" value={getParamValue('elementId')} onChange={setParam} />
          <FormCheckbox
            name="responsiveHide"
            onChange={this.handleResponsiveHideChange}
            label={messages.hide_on_devices}
            values={this.getValues()}
            options={[
              { value: 'phone', label: messages.mobile_phones },
              { value: 'tablet', label: messages.tablets },
              { value: 'desktop', label: messages.desktop_pcs },
            ]}
          />

          {element.type === 'row' && (
            <FormCheckbox
              name="rowSameHeight"
              onChange={this.handleRowSameHeightChange}
              label={messages.same_col_height}
              values={this.getValues()}
              options={[
                { value: 'phone', label: messages.mobile_phones },
                { value: 'tablet', label: messages.tablets },
                { value: 'desktop', label: messages.desktop_pcs },
              ]}
            />
          )}
        </div>
      </>
    );
  }
}

export default injectIntl(CmsCommonSettings);
